import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import UserList from '../views/UserList.vue'
import ProgramList from '../views/ProgramList.vue'
import GroupList from '../views/GroupList.vue'
import GroupJournal from '../views/GroupJournal.vue'
import ContractList from '../views/ContractList.vue'
import CourseList from '../views/CourseList.vue'
import RecordList from '../views/RecordList.vue'
import Auth from '../views/Auth.vue'
import NotFound from '../views/NotFound.vue'

function IsAuthorized() {
    return localStorage.getItem("tok") != null
}

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: () => {
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/users',
        name: 'UserList',
        component: UserList,
        beforeEnter: () => {
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/programs',
        name: 'ProgramList',
        component: ProgramList,
        beforeEnter: () => {
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/groups',
        name: 'GroupList',
        component: GroupList,
        beforeEnter: () => {
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/journal',
        name: 'GroupJournal',
        component: GroupJournal,
        beforeEnter: () => {
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/contract_journal',
        name: 'ContractList',
        component: ContractList,
        beforeEnter: () => {
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/course_list',
        name: 'CourseList',
        component: CourseList,
        beforeEnter: () => {
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/record_list',
        name: 'RecordList',
        component: RecordList,
        beforeEnter: () => {
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/auth',
        name: 'Auth',
        component: Auth,
        beforeEnter: () => {
            if (IsAuthorized()) {
                router.push({ name: 'Home' })
            }
        }
    },
    {
        path: '/logout',
        name: 'Logout',
        beforeEnter: () => {
            const mode = localStorage.getItem("mode")
            localStorage.clear()
            if (mode !== null) {
                localStorage.setItem("mode", mode)
            }
            router.push({ name: 'Auth' })
        }
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router